import { FC } from 'react'

import { ManagedUnitAvailabilityStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { parseLabel } from '@new/domains/operations/utils/parseLabel'

interface PropertyStatusFilterProps extends FiltersProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

const options = Object.values(ManagedUnitAvailabilityStatus).map(status => ({
  value: status,
  hasFullWidth: true,
  label: parseLabel(status),
}))

export const PropertyStatusFilter: FC<PropertyStatusFilterProps> = props => {
  return <CheckboxBasedFilter title="Property Status" options={options} {...props} />
}
